import Vue from 'vue'
import axios from 'axios';

//sistema cidadao

Vue.prototype.$listarUsuarios = async () => {
  try {
    let res = await axios.get('users/sistema', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$manifestarIdCidadao = async (cidadao_id,manifesto) =>{
  try { 
    let res = await axios.post('/manifestacaos',{
        anonimo: 0,
        id_usuario: cidadao_id, 
        tipo_usuario: 'cidadao',
        tipo_assunto: manifesto['tipo'],
        secretaria: manifesto['secretaria'],
        assunto: manifesto['assunto'],
        conteudo: manifesto['descricao'],
        rua: manifesto['rua'],
        numero: manifesto['numero'],
        bairro: manifesto['bairro'],
        complemento: manifesto['complemento'],
        sigilo: manifesto['sigilo'],
    });
    return res.data;
  } catch (e) {
    throw e;
  }  
}

Vue.prototype.$assuntos = async () =>{
  try { 
    let res = await axios.get('assuntos/todos',{});
    return res.data;
  } catch (e) {
    throw e;
  }  
}

Vue.prototype.$secretaria = async () =>{
  try { 
    let res = await axios.get('secretaria/todos',{});
    return res.data;
  } catch (e) {
    throw e;
  }  
}

Vue.prototype.$conversaManifestoCidadao = async (manifestacao,cidadao,usuariosistema,assunto,tipo,conversa_cidadao) => {
  try {
    let res = await axios.post('conversa/manifestacao/'+manifestacao+'/'+cidadao+'/'+ usuariosistema,{
      assunto: assunto,
      tipo: tipo,
      conversa_cidadao: conversa_cidadao
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$ListarConversaIdC = async (uuid) => {
  try {
    let res = await axios.get('conversa/manifestacao/id/'+uuid, {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$listarManifestosCidadao = async (uuid) => {
  try {
    let res = await axios.get('cidadao/'+uuid+'/manifestacao', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

